import { GlobalExclusionsAppBaseDataProvider } from './GlobalExclusionsAppBaseDataProvider';

export class GlobalExclusionsAppGzDataProvider extends GlobalExclusionsAppBaseDataProvider {

}
